// Import model
import { CreateProjectSelectionRequest } from '../models/CreateProjectSelectionRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreateSelectionBinRequest } from '../models/CreateSelectionBinRequest';

// Import dependency serializers (for complex types)
import { CreateSelectionBinRequestSerializer } from './CreateSelectionBinRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateProjectSelectionRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateProjectSelectionRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateProjectSelectionRequest instance
   */
  static deserialize(json: string): CreateProjectSelectionRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateProjectSelectionRequest instance
   */
  static fromObject(obj: any): CreateProjectSelectionRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateProjectSelectionRequest');
    }


    const instance: CreateProjectSelectionRequest = {
      itemIds: obj['itemIds'] ? (obj['itemIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      selectionBins: obj['selectionBins'] ? (obj['selectionBins'] as any[]).map((item: any) =>
        CreateSelectionBinRequestSerializer.fromObject(item)
      ) : [] as any,
      name: obj['name'] as string | undefined,
      description: obj['description'] as string | undefined,
      entityId: obj['entityId'] as string | undefined,
      parentObjectId: obj['parentObjectId'] as string,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateProjectSelectionRequest instances
   */
  static deserializeArray(json: string): CreateProjectSelectionRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateProjectSelectionRequest instance to a JSON string
   */
  static serialize(instance: CreateProjectSelectionRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateProjectSelectionRequest instance to a plain object
   */
  static toObject(instance: CreateProjectSelectionRequest): any {
    return {
      'itemIds': instance.itemIds?.map((item: any) =>
        item
      ),
      'selectionBins': instance.selectionBins?.map((item: any) =>
        CreateSelectionBinRequestSerializer.toObject(item)
      ),
      'name': instance.name,
      'description': instance.description,
      'entityId': instance.entityId,
      'parentObjectId': instance.parentObjectId,
    };
  }

  /**
   * Serializes an array of CreateProjectSelectionRequest instances to a JSON string
   */
  static serializeArray(instances: CreateProjectSelectionRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
